import React from 'react';
import { Icon } from '../../Icon/Icon';
import { type IconGlyph, isIconGlyph } from '../../Icon/IconGlyph';

export const renderIcon = (iconSource: IconGlyph | React.ReactNode) => {
  if (!iconSource) {
    return null;
  }
  if (isIconGlyph(iconSource)) {
    return <Icon size='sm' glyph={iconSource} className='shrink-0' />;
  }
  if (React.isValidElement(iconSource)) {
    return iconSource;
  }
  return null;
};
